export const internalImageRemotePatterns = [
  {
    protocol: 'https',
    hostname: 'skin-seoul.com',
  },
  {
    protocol: 'https',
    hostname: 'dev.skin-seoul.com',
  },
  {
    protocol: 'https',
    hostname: 'dev-webapp.skin-seoul.com',
  },
  {
    protocol: 'https',
    hostname: 'staging-webapp.skin-seoul.com',
  },
  {
    protocol: 'https',
    hostname: 'staging.skin-seoul.com',
  },
  {
    protocol: 'https',
    hostname: 'prod.skin-seoul.com',
  },
  {
    protocol: 'https',
    hostname: 'dev-banners.skin-seoul.com',
  },
];
